<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <h4 class="title is-4">{{createOrUpdate}}</h4>
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label is-small">Employee</label>
          <div class="control">
            <b-autocomplete v-model="employeeName" size="is-small" :data="employees" placeholder="Search employees" @select="option => selectedEmployee = option" @input="searchEmployees" :loading="isFetchingEmployees" v-validate="'required'" name="Employee name">
              <template slot="empty">
                <span v-if="isFetchingEmployees">
                  Please wait...
                </span>
                <span v-if="employees.length === 0">
                  No results found
                </span>
              </template>
            </b-autocomplete>
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Employee name') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Firstname</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="user.firstname" :disabled="isFieldDisabled" />
          </div>
        </div>
        <div class="field">
          <label class="label">Lastname</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="user.lastname" :disabled="isFieldDisabled" />
          </div>
        </div>
        <div class="field">
          <label class="label">Email</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="user.email" :disabled="isFieldDisabled" autocomplete="false" />
          </div>
        </div>
        <div class="field">
          <label class="label">Email Password</label>
          <div class="control">
            <div v-if="isCreate">
              <div class="control">
                <input type="password" class="input is-small" v-model="user.emailPassword" :disabled="isFieldDisabled" autocomplete="false" />
              </div>
            </div>
            <div v-else>
              <div class="columns">
                <div class="column">
                  <input type="password" class="input is-small" v-model="replaceEmailPass.newPassword" autocomplete="false" />
                </div>
                <div class="column">
                  <button class="button is-small" @click="replaceEmailPassword">Change Email Password</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Username</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="user.userName" />
          </div>
        </div>
        <div v-if="isCreate">
          <div class="field">
            <label class="label">Password</label>
            <div class="control">
              <input type="password" class="input is-small" v-model="user.password" />
            </div>
          </div>
          <div class="field">
            <label class="label">Confirm Password</label>
            <div class="control">
              <input type="password" class="input is-small" />
            </div>
          </div>
          <div style="display:block"></div>
        </div>
        <div v-else>
          <div class="field">
            <label class="label">Replace Password</label>
            <div class="columns">
              <div class="column">
                <input type="password" class="input is-small" v-model="replacePass.newPassword" />
              </div>
              <div class="column">
                <button class="button is-small" @click="replacePassword">Replace Password</button>
              </div>
            </div>
          </div>
          <div style="display:block"></div>
        </div>
        <div class="field">
          <label class="label">Role(s)</label>
          <div class="control">
            <b-checkbox v-model="userRolesForCheckbox" native-value="Admin" class="is-small">
              Admin
            </b-checkbox>
            <b-checkbox v-model="userRolesForCheckbox" native-value="Staff" class="is-small">
              Staff
            </b-checkbox>
            <b-checkbox v-model="userRolesForCheckbox" native-value="Employee" class="is-small">
              Employee
            </b-checkbox>
          </div>
          <span class="has-text-danger">
            <i>{{updateNote}}</i>
          </span>
        </div>
        <div style="float:right">
          <button :class="successButton" @click="saveUser">
            <span class="icon">
              <i class="fas fa-save"></i>
            </span>
            &nbsp; Save
          </button> &nbsp;
          <router-link to="/user-managements" class="button is-small">
            <span class="icon">
              <i class="fas fa-arrow-left"></i>
            </span>&nbsp; Go back to list</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import debounce from 'lodash/debounce'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      user: {
        userRoles: []
      },
      userRolesForCheckbox: [],
      isCreate: true,

      replacePass: {},
      replaceEmailPass: {},

      updateNote: '',

      successButton: appButton.isLoadingSuccess(false),
      createOrUpdate: 'Create',
      isFullPage: true,
      isLoading: false,
      isFieldDisabled: false,
      // select
      employees: [],
      selectedEmployee: 0,
      employeeName: '',
      isFetchingEmployees: false
    }
  },
  methods: {
    default() {
      this.user = {
        userRoles: []
      }
      this.updateNote = ''
      this.$router.push('/user-managements')
    },
    searchEmployees: debounce(function() {
      this.isFetchingEmployees = true
      axios
        .get(`api/employees/search-by-name/${this.employeeName}`)
        .then(response => {
          this.employees = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingEmployees = false
        })
    }, 500),
    replacePassword() {
      const userId = this.$route.params.userId
      if (userId) {
        this.replacePass.id = userId
        axios
          .post(`api/users/replace-pass/`, this.replacePass)
          .then(response => {
            appToast.success(response.data)
          })
          .catch(error => {
            appToast.danger(error)
          })
      }
    },
    replaceEmailPassword() {
      const userId = this.$route.params.userId
      if (userId) {
        this.replaceEmailPass.id = userId
        axios
          .post('api/users/replace-email-pass', this.replaceEmailPass)
          .then(response => {
            appToast.success(response.data)
          })
          .catch(error => {
            appToast.danger(error)
          })
      }
    },
    saveUser() {
      if (!this.user) {
        return false
      }
      this.successButton = appButton.isLoadingSuccess(true)
      this.user.userRoles = this.userRolesForCheckbox.map(role => ({ role }))
      const userId = this.$route.params.userId
      if (userId) {
        // update
        this.user.id = userId

        axios
          .put(`api/users/${this.user.id}`, this.user)
          .then(response => {
            appToast.success(response.data)

            this.updateNote =
              'Note: Role changes will take effect after this user is re-logging in'
          })
          .catch(error => {
            appToast.danger(error)
          })
          .then(() => {
            this.successButton = appButton.isLoadingSuccess(false)
          })
      } else {
        // create
        axios
          .post('api/users', this.user)
          .then(response => {
            appToast.success(response.data)
            this.default()
          })
          .catch(error => {
            appToast.danger(error)
          })
          .then(() => {
            this.successButton = appButton.isLoadingSuccess(false)
          })
      }
    }
  },
  created() {
    const userId = this.$route.params.userId
    if (userId) {
      this.isLoading = true
      this.createOrUpdate = 'Update'
      axios
        .get(`api/users/${userId}`)
        .then(response => {
          this.user = response.data

          this.userRolesForCheckbox = this.user.userRoles.map(
            ({ role }) => role
          )

          this.isCreate = false
        })
        .catch(error => {
          appToast.danger('Something went wrong. Redirecting to list of users')
          console.log(error)
          this.$router.push('/user-managements')
        })
        .then(() => {
          this.isLoading = false
        })
    }
  },
  watch: {
    selectedEmployee() {
      if (this.selectedEmployee) {
        this.user.employeeId = this.selectedEmployee.pkey
        this.isFieldDisabled = true
      } else {
        this.user.employeeId = null
        this.isFieldDisabled = false
      }
    }
  }
}
</script>
